import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import AfterPeyment from "./Components/AfterPeyment";
import OrderDetails from "./Components/OrderDetails";
import Partner from "./Components/Partner";
import Peyment from "./Components/Peyment";
import { useCard } from "./Hooks";
import { BsCheck2Circle } from "react-icons/bs";
import { TbChecklist } from "react-icons/tb";
import InSetBoxShadow from "../../Common/InSetBoxShadow";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import AppCard from "../../../App/Views/Card";
const Card = ({ isApp }) => {
  const {
    createPartners,
    changeStep,
    code,
    setCode,
    storeReserve,
    loading,
    kind,
    setKind,
  } = useCard();
  const { basket } = useSelector(state => state);
  // const navigate = useNavigate();

  const renderData = () => {
    // swith basket.step
    switch (basket.step) {
      case 1:
        return isApp ? <AppCard /> : <OrderDetails />;
      case 2:
        return <Partner />;
      case 3:
        return (
          <Peyment
            code={code}
            setCode={setCode}
            kind={kind}
            setKind={setKind}
          />
        );
      case 4:
        return <AfterPeyment />;
      default:
        break;
    }
  };
  const renderReserve = () => {
    if (loading.reserve) {
      return "در حال پردازش";
    } else {
      if (kind == "wallet") {
        return "پرداخت با کیف پول";
      }
    }
    return "پرداخت آنلاین";
  };
  if (!basket.item) {
    return (
      <div className="container py-5 empty-bag">
        <div className="row" style={{ minHeight: "250px" }}>
          <div className="col-12">
            <InSetBoxShadow className="d-flex flex-column justify-content-center align-items-center py-5 px-2">
              <img
                src={window.origin + "/WebSide/assets/images/bag.png"}
                alt="سبد خرید"
              />
              <h5 className="text-center mt-4">سبد خرید شما خالی است!</h5>
              <p className="mt-2 text-center" style={{ color: "#404040" }}>
                می‌توانید برای مشاهده باشگاه ها و کلاس ها به صفحات زیر بروید:
              </p>
              <div className="d-flex justify-content-center mt-4">
                <Link
                  className="px-3"
                  style={{ borderLeft: "1px solid #ccc" }}
                  to="/items"
                >
                  مجموعه های ورزشی
                </Link>
                <Link className="px-3 " to="/Classes/List">
                  کلاس های ورزشی
                </Link>
              </div>
            </InSetBoxShadow>
          </div>
        </div>
      </div>
    );
  }
  const checkPartners = () => {
    let userInterface = ["fullname", "mobile", "national_code"];

    let res = { status: true };
    basket.otherpeopel.map(user => {
      userInterface.map(ele => {
        if (!user[ele]) {
          res = { status: false };
        }
      });
    });
    return res;
  };
  let steps = [
    {
      doneImage: window.origin + `/WebSide/assets/images/shif.png`,
      img: window.origin + `/WebSide/assets/images/shif.png`,
      text: "انتخاب شیفت",
      step: 0,
    },
    {
      img: window.origin + `/WebSide/assets/images/sef.png`,
      doneImage: "/WebSide/assets/images/sef.png",
      text: "اطلاعات سفارش",
      step: 1,
    },
    // {
    //   img: window.origin + `/WebSide/assets/images/et.png`,
    //   doneImage: window.origin + `/WebSide/assets/images/etf.png`,
    //   text: "اطلاعات هویتی",
    //   step: 2,
    // },
    // {
    //   img: window.origin + `/WebSide/assets/images/sabad.png`,
    //   doneImage: window.origin + `/WebSide/assets/images/sabadf.png`,
    //   text: "سبد خرید و پرداخت",
    //   step: 3,
    // },
    {
      img: window.origin + `/WebSide/assets/images/bilit.png`,
      doneImage: window.origin + `/WebSide/assets/images/bilitf.png`,
      text: "دریافت بلیت",
      step: 4,
    },
  ];
  const renderState = step => {
    if (+basket.step >= +step.step) {
      return {
        img: step.doneImage,
        style: { color: "#65CB77", height: "2px", opacity: 1 },
      };
    } else {
      return {
        img: step.img,
        style: { height: "2px", opacity: 1 },
      };
    }
  };

  return (
    <>
      <Helmet>
        <title>نیکوتن | سبد خرید</title>
        <meta
          name="description"
          content="نیکوتن جامع ترین سامانه معرفی، اطلاع رسانی و رزرو آنلاین استخر و پارک های آبی، باشگاه های بدنسازی، سالن های ورزشی و کلاس های ورزشی با تخفیف های ویژه
"
        />
        <link rel="canonical" href={window.origin + `/card`} />
      </Helmet>
      <div id="card-page" style={{ backgroundColor: "#F6F6F6" }}>
        <InSetBoxShadow className="bg-white border-0">
          <div className={isApp ? "container p-2" : "container py-3 py-md-5"}>
            <div className="row justify-content-center">
              <div className="col-12 position-relative px-0 py-0">
                <div
                  className={
                    "step-container flex-wrap flex-wrap flex-sm-nowrap " +
                    ("step-" + basket.step)
                  }
                >
                  {steps.map(step => {
                    const { img, style } = renderState(step);
                    return (
                      <div
                        key={step.step}
                        className={"d-flex flex-row flex-sm-column " + (isApp ? "" : "mb-3 mb-sm-2 mb-md-0 ")}
                      >
                        <div>
                          <img
                            src={img}
                            alt="همه ملاقات"
                            className={step.step == 3 ? "ms-3 ms-sm-0" : "" + (isApp && " ml-2 wh20px")}
                          />
                        </div>
                        <div className="mt-1 mt-sm-2">
                          {isApp
                            ? <p className={"mb-0 nfs-11"}>{step.text}</p>
                            : <h6 >{step.text}</h6>
                          }
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </InSetBoxShadow>
        <div className={(window.screen.width < 992 ? "px-2 py-3" : "container py-5")}>
          {renderData()}

          {/* <div className="row justify-content-between " style={{ margin: "60px 0" }} >
            <div className="col-6 d-flex m-0 p-0">
              <button
                onClick={() => {
                  if (basket.step == 1) {
                    navigate(-1);
                  }
                  changeStep(basket.step - 1);
                }}
                style={{
                  border: "none",
                  backgroundColor: "#E42A3F",
                  color: "#fff",
                  padding: "5px 20px",
                  borderRadius: "10px",
                }}
              >
                مرحله قبل
              </button>
            </div>

            <div className="col-6 d-flex justify-content-end m-0 p-0">
              {basket.step == 3 ? (
                <>
                  <button
                    style={{
                      border: "none",
                      backgroundColor: "#E42A3F",
                      color: "#fff",
                      padding: "5px 20px",
                      borderRadius: "10px",
                    }}
                    onClick={() => storeReserve(kind)}
                    disabled={loading.reserve}
                  >
                    {renderReserve()}
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => {
                      if (basket.step === 1) {
                        if (basket.promise) {
                          createPartners();
                        } else {
                          toast.error("لطفا قوانین باشگاه را تایید کنید");
                        }
                      } else if (basket.step === 2) {
                        if (!checkPartners()["status"]) {
                          toast.error("اطلاعات همراهان کامل نیست");
                        } else {
                          changeStep(basket.step + 1);
                        }
                      } else if (basket.step == 3) {
                      } else {
                        changeStep(basket.step + 1);
                      }
                    }}
                    style={{
                      border: "none",
                      backgroundColor: "#E42A3F",
                      color: "#fff",
                      padding: "5px 20px",
                      borderRadius: "10px",
                    }}
                  >
                    تایید و ادامه
                  </button>
                </>
              )}
            </div>
          </div> */}

        </div>
      </div>
    </>
  );
};

export default Card;
